
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UiSpinner} from "./spinner";
import {EscapePipe} from "./escape";
import {ErrorComponent} from "./error";
import {FormFieldComponent} from "./form-field";
import { FormRadioFieldComponent } from "./form-radio-field";
import { FormSelectFieldComponent } from './form-select-field';

/** The NgModule for the UI feature */
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ],
    declarations: [
        UiSpinner,
        EscapePipe,
        ErrorComponent,
        FormFieldComponent,
        FormRadioFieldComponent,
        FormSelectFieldComponent
    ],
    exports: [
        UiSpinner,
        EscapePipe,
        ErrorComponent,
        FormFieldComponent,
        FormRadioFieldComponent,
        FormSelectFieldComponent
    ]
})
class AppUiModule {}

export {AppUiModule};